'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = uploadListItemFile;

var _readFileToString = require('../readFileToString');

var _readFileToString2 = _interopRequireDefault(_readFileToString);

var _respToJson = require('../respToJson');

var _respToJson2 = _interopRequireDefault(_respToJson);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Upload file as attachment to a list item.
 *
 * @param {string} list Name of list.
 * @param {string} id Id of item.
 * @param {File} file File object from upload.
 * @return {Promise}
 */
function uploadListItemFile(list, id, file) {
    var siteurl = window._spPageContextInfo.webServerRelativeUrl;
    var urlTemplate = siteurl + '/_api/web/lists/getByTitle(\'' + list + '\')/items(' + id + ')/AttachmentFiles/add(FileName=\'' + file.name + '\')';
    var requestDigest = document.getElementById('__REQUESTDIGEST');

    return (0, _readFileToString2.default)(file).then(function (filedata) {
        return fetch(urlTemplate, {
            credentials: 'same-origin',
            method: 'POST',
            headers: {
                'Accept': 'application/json;odata=verbose',
                'Content-Type': 'application/json;odata=verbose',
                'Content-Length': filedata.length,
                'X-RequestDigest': requestDigest && requestDigest.value || '',
                'binaryStringRequestBody': 'true'
            },
            body: filedata
        });
    }).then(_respToJson2.default);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/ntnu-react/util/sp/uploadListItemFile.js
// module id = 679
// module chunks = 0